import { render, staticRenderFns } from "./printOrderDetails.vue?vue&type=template&id=2df49752&scoped=true&"
import script from "./printOrderDetails.vue?vue&type=script&lang=js&"
export * from "./printOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./printOrderDetails.vue?vue&type=style&index=0&id=2df49752&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df49752",
  null
  
)

component.options.__file = "printOrderDetails.vue"
export default component.exports